import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#0a0a0a', flexDirection: 'column', gap: '1rem'
      }}>
        <div style={{
          width: 36, height: 36,
          border: '3px solid rgba(232,71,30,0.2)',
          borderTopColor: '#E8471E',
          borderRadius: '50%',
          animation: 'spin 0.7s linear infinite'
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // Not logged in at all
  if (!user) return <Navigate to="/login" replace />;

  // Logged in but not admin — show access denied
  if (!isAdmin) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#0a0a0a', flexDirection: 'column',
        gap: '1rem', textAlign: 'center', padding: '2rem'
      }}>
        <div style={{ fontSize: '3rem' }}>🚫</div>
        <h1 style={{ color: '#f0ede8', fontSize: '1.5rem', fontWeight: 600 }}>Access Denied</h1>
        <p style={{ color: '#666', maxWidth: 360 }}>
          You do not have administrator privileges to access this portal.
          Please contact your system administrator.
        </p>
        <button onClick={() => window.location.href = '/login'}
          style={{
            background: '#E8471E', color: '#fff', border: 'none',
            borderRadius: 8, padding: '0.7rem 1.5rem', cursor: 'pointer',
            fontFamily: 'inherit', fontSize: '0.9rem', marginTop: '0.5rem'
          }}>
          Back to Login
        </button>
      </div>
    );
  }

  return children;
};

export default AdminProtectedRoute;
